import { svg, html, css } from 'lit';
import { HyphenationModule } from '../js/modules/hyphenation.module';
import { LineClampModule } from '../js/modules/line-clamp.module';
import { NexusComponent } from './modules/nexus.component';
import { DebounceModule } from './modules/debounce.module';
/**
 * Progressively enhanced grid-item component.
 * Works with SEO while providing a base for js-based features.
 * Styles are encapsulated.
 * TODO: use modular scss and improve encapsulated modularity.
 */
export class GridItemComponent extends NexusComponent {

    static properties = {
        title: {
            type: String,
            attribute: true,
        },
        // myBool: { type: Boolean },
    }

    sprites;

    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
			display: flex;  /* or display: block; */
            width: 100% !important;
			}
            .grid-item-component {
                width: 100%;
            }
		`;
    }
    constructor() {
        super();
        this.title = null;
        this.lineClampModule = new LineClampModule();
        this.lineClampModule.initialize();
        if (typeof document !== 'undefined') {
            this.triggerEventOnElement('constructor', document, this);
            this.triggerEventOnElement('constructor.grid-item.component', document, this);
        }
    }

    initialize() {
        // console.log('initial load of grid item large component. Not actually needed for this component to function.');
        // you could load something here at the beginning if you want. But the definition is automatic given a window.customElements.define definition...
    }

    getSprites() {
        return svg`${this.sprites}`;
    }

    // // TODO: Important! Use 'updated' instead of 'update' because 'update' is used to update, and 'updated' is used to handle updated DOM
    updated() {
        super.updated();
        this.triggerEventOnElement('updated.grid-item.component', document, this);
    }

    connectedCallback() {
        super.connectedCallback();
        this.hyphenationModule = new HyphenationModule();
        this.triggerEventOnElement('connected.grid-item.component', document, this);
    }
    render() {
        var result = html`
        <div class="grid-item-component" component-loaded>
            <slot @slotchange=${this.handleSlotChange}></slot>
        </div>
        `;
        this.triggerEventOnElement('render.grid-item.component', document, this);
        return result;
    }

    handleSlotChange(event) {
        // console.log('handleSlotChange', event);
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });
    }

    firstUpdated() {
        this._slottedChildren.forEach((element) => {
            this.hyphenationModule.setRoot(element);
            this.hyphenationModule.initialize();
        });
    }

}
window.customElements.define('grid-item', GridItemComponent);
